import React from 'react';
import { useDispatch } from 'react-redux';
import { ResetUnlockedAccount } from '../../reduxToolkit/CompanyEmployees/CompanyEmployeesApi';
import ButtonAction from './ButtonAction';
import {IdentityT} from './IconButtons';
import {errorCodeTranslation} from '../../Apis/ErrorCode';
import {toast} from 'react-toastify';
import {useTranslation} from 'react-i18next';

const BtnResetByImpersonation = ({ id }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const sendResetByImpersonation = () => {
        dispatch(ResetUnlockedAccount(id)).then(({payload: {data: { success, code }}}) => {
            if(!success){
                const errorMessage = errorCodeTranslation[code] ? t(errorCodeTranslation[code]) : t('something_went_wrong_2');
                toast.error(errorMessage);
            }
        });
    };

    return (
        <ButtonAction
            id='btn_brbi_reset_impersonation'
            name='reset_by_impersonation'
            className='btn-icon-accent-450'
            Icon={IdentityT}
            disabled={false}
            splitName={false}
            onClick={()=>{
                sendResetByImpersonation();
            }}
        />
    );
};

export default BtnResetByImpersonation;
